import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HrmLocationService {


  url = environment.serverAPI6 + "/api/hrmLocation";

  constructor(private http: HttpClient) { }

  getAllhrmLocation(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllHrmLocationDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }


  getHrmLocationById(locationId: number): Observable<Object> {
    return this.http.get(`${this.url}/${locationId}`);
  }

  addOrEdithrmLocation(warehouses: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, warehouses);
  }

  hrmLocationSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }

  downloadHrmLocationTemplate(): Observable<any> {
    return this.http.get(`${this.url}/template/download`, { responseType: 'arraybuffer', observe: 'response' });
  }

  downloadHrmLocationReport(Page: number, size: number, sort, selectionUnits): Observable<any> {
    return this.http.post(`${this.url}/export/page?page=${Page}
      &size=${size}&sort=${sort}`, selectionUnits, {
      responseType: 'arraybuffer',
      observe: 'response'
    });
  }


  getAllHrmlocationGeoDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/list`);
  }

}

